import { GPM } from '../gpmAPI';

const applicationApi = GPM.injectEndpoints({
	endpoints: (builder) => ({
		deleteApplication: builder.mutation({
			query: (props) => ({
				url: `/applications/${props.uniqueIdentifier}/delete/`,
				method: 'POST',
				headers: {
					Authorization: `Bearer ${props?.apiToken}`
				}
			})
		})
	})
});

export const { useDeleteApplicationMutation } = applicationApi;
